import { useEffect, useState } from "react"

import {
  useForm,
  usePayloadFormatters,
  useStepTransition
} from "@garantidos/hooks"
import { httpRequests, proposalHttpController } from "@garantidos/services"
import {
  clearStorage,
  focusOnLogo,
  getItem,
  setCpfInStorage,
  setItem
} from "@garantidos/utils"
import { trackEvent } from "@garantidos/utils/tracking"

import useMediaQuery from "@mobi/hooks/useMediaQuery"

import validatorsDictionary from "pages/Proposal/hooks/validators"

import { ProposalContext, useProposalContext } from "contexts/proposal"

import { fields } from "./fields"
import * as trackers from "./trackings"

const useSoftlead = () => {
  const { hashDocument } = httpRequests

  const { form } = useForm({
    fields,
    context: ProposalContext,
    validatorsDictionary
  })

  const { setValue } = form

  const {
    cpfData,
    sendProposalData,
    errorMessage,
    setErrorMessage,
    errorHandler,
    isLoading,
    setIsStepVisible,
    updateCpfData
  } = useProposalContext()

  const { stepNavigator } = useStepTransition(setIsStepVisible)
  const { formatSendPayload } = usePayloadFormatters(fields)
  const [isFormLoading, setIsFormLoading] = useState(false)

  const { hashedCpf } = cpfData
  const isMobile = useMediaQuery("mobile")

  const handleCpf = async (cpf) => {
    setIsFormLoading(true)
    let hashedCpfFromHero = await hashDocument(cpf)

    const trackingInfoEvent = {
      event: {
        ga: {
          label: "BTN:Inicio:Continuar",
          action: "Inicio",
          hashedCpf: hashedCpfFromHero
        },
        ga4: {
          customPath: "inicio/landing-page",
          hashedCpf: hashedCpfFromHero,
          implementationTeam: "cgi:v01",
          detail: "landing-page-simule-agora",
          eventName: "click"
        }
      }
    }
    trackEvent(trackingInfoEvent.event)
    trackers.pageview(hashedCpfFromHero)

    setValue("proponent_document", cpf, {
      shouldValidate: true,
      shouldTouch: true
    })
    setIsFormLoading(false)
    try {
      await updateCpfData({ cpf, hashedCpf: hashedCpfFromHero })
    } catch (error) {
      console.log(error)
      trackers.alert(hashedCpfFromHero, error)
    } finally {
      const ignoreItens = ["appGeoloc", "appToken", "eq3_uuid"]
      clearStorage(ignoreItens)
      setCpfInStorage({ cpf, hashedCpf: hashedCpfFromHero })
    }
  }

  const trackDsBackButton = () => {
    trackers.backHome(hashedCpf)
  }

  useEffect(() => {
    const cpf = getItem("cpfFromHero")

    if (cpf) {
      handleCpf(cpf)
    } else {
      trackers.pageview()
    }

    focusOnLogo()

    const back = document.getElementById("main-logo")
    back.onclick = () => trackDsBackButton()
  }, [])

  const onSubmitCallback = async (formData) => {
    if (isLoading) return

    let hashedCpfFromForm = await hashDocument(formData.proponent_document)
    try {
      const payload = formatSendPayload(formData)
      payload.mobile = isMobile

      const response = await sendProposalData({
        payload,
        clearStepNaviagation: false
      })
      const nextStep = response.stepNavigation.currentStep
      setItem("eq3_uuid", response?.stepData?.eq3_uuid)
      stepNavigator("next", nextStep)
      trackers.advance(hashedCpfFromForm)
    } catch (error) {
      trackers.alert(hashedCpfFromForm, error)
      errorHandler(error)
    }
  }

  return {
    onSubmitCallback,
    fields,
    form,
    errorMessage,
    setErrorMessage,
    isLoading,
    isFormLoading
  }
}

export default useSoftlead
